// extracted by mini-css-extract-plugin
export var addressFields = "_n2-0";
export var animationContainer = "_n2-1";
export var footer = "_n2-2";
export var lineItems = "_n2-3";
export var modalContent = "_n2-4";
export var orderName = "_n2-5";
export var strong = "_n2-6";
export var warning = "_n2-7";